import { render, staticRenderFns } from "./VerFaq.vue?vue&type=template&id=4d7b860d&"
import script from "./VerFaq.vue?vue&type=script&lang=js&"
export * from "./VerFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports